// SciChart 2.2 stawia dymek rollovera na prawo od punktu, a gdy się tam nie
// mieści — przesuwa go o całą szerokość w lewo, nie sprawdzając lewej krawędzi.
// Na wąskich wykresach (karty wagi stada) dymek wychodził wtedy poza płótno.
//
// Przesunięcie w poziomie liczy tylko calcTooltipProps, a RolloverModifier woła
// ją przez obiekt exports swojego modułu (CommonJS), więc wystarczy ją opakować:
// poprawione przesunięcie trafia do dymka od razu, bez dodatkowego renderowania.
// Import w main.js — działa dla wszystkich wykresów z rolloverem.
const rolloverModule = require("scichart/Charting/ChartModifiers/RolloverModifier");

const calcTooltipProps = rolloverModule.calcTooltipProps;

rolloverModule.calcTooltipProps = function (index, rs, rolloverProps, seriesViewRect, xValue, yValue, absoluteXCoord, absoluteYCoord, hitTestInfo, pixelRatio, isY1, isVerticalChart) {
    const props = calcTooltipProps.apply(this, arguments);
    if (!props || isVerticalChart) {
        return props;
    }

    // Współrzędne i szerokość obszaru serii są w pikselach płótna (× pixelRatio),
    // przesunięcie i szerokość dymka — w pikselach CSS.
    const width = rolloverProps.tooltip.width;
    const x = absoluteXCoord / pixelRatio;
    const viewWidth = seriesViewRect.width / pixelRatio;
    const left = x + props.xCoordShift;

    if (left >= 0 && left + width <= viewWidth) {
        return props;
    }

    // Strona punktu z większą ilością miejsca, potem dociągnięcie do krawędzi.
    const shift = viewWidth - x >= x ? 5 : -width;
    props.xCoordShift = Math.min(Math.max(shift, -x), viewWidth - width - x);
    return props;
};



// WEBPACK FOOTER //
// ./src/utils/sciChartRollover.js